import React from "react";
import Step from "./Step";
import SubstrateAccountPicker from "./SubstrateAccountPicker";
import { InjectedAccountWithMeta } from "@polkadot/extension-inject/types";

interface Step1Props {
  currentStep: number;
  setCurrentStep: (account: number) => void;
  setSubstrateAccount: (account: InjectedAccountWithMeta) => void;
}

const Step1: React.FC<Step1Props> = ({
  currentStep,
  setCurrentStep,
  setSubstrateAccount,
}) => {
  return (
    <Step
      stepNum={1}
      currentStep={currentStep}
      title="Choose Your Substrate Account"
    >
      <div className="flex flex-col justify-center items-start gap-2 py-3">
        <SubstrateAccountPicker
          setAccount={(account) => {
            if (currentStep === 1) {
              setCurrentStep(currentStep + 1);
              setSubstrateAccount(account);
            }
          }}
          currentStep={currentStep}
        />
      </div>
    </Step>
  );
};

export default Step1;
